<template>
  <div class="wrap">
    <h1 class="common-header">{{ $t('1944') }}</h1>
    <div class="by-content">
      <div class="form-wrap" ref="formWrap">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item :label="$t('142')">
            <el-input
              class="search_name"
              v-model="form.search_name"
              :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('307')">
            <datePacker
              @input="handlerInputChange"
              format="yyyy-MM-dd"
              valueFormat="yyyy-MM-dd"
              class="date-picker-gl"
              :isShowHeader="true"
            />
          </el-form-item>
          <el-form-item :label="$t('27')" prop="region">
            <department :change="handlerChangeDep" :mprop="{ checkStrictly: true }" :placeholder="$t('221')" />
          </el-form-item>
          <el-form-item :label="$t('24')" prop="region">
            <job v-model="form.job_title_id" />
          </el-form-item>
          <!-- 在职状态 -->
          <el-form-item :label="$t('state')" prop="region">
            <el-select v-model="form.states" :placeholder="$t('405')" multiple clearable collapse-tags>
              <el-option v-for="item in stateArr" :key="item.key" :label="item.value" :value="item.key"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handlerSearch">{{ $t('69') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-download" @click="handlerAttendanceExcel" v-if="$p('menu.statistics.export')">{{
              $t('68')
            }}</el-button>
          </el-form-item>
        </el-form>
        <!-- 动态展示列 -->
        <!-- <el-checkbox-group v-model="checkList" @change="handlerChangeSelect">
          <el-checkbox :label="item.label" v-for="(item, index) in checkData" :key="index"></el-checkbox>
        </el-checkbox-group> -->
        <!-- 加班动态展示 -->
        <!-- <el-checkbox v-model="overTime" key="overtime"> {{ $t('82') }} </el-checkbox> -->
        <!-- 色块区分 -->
        <ul class="colors-wrap">
          <li class="warn-color" v-for="item in colors" :key="item.color">
            <span class="warn-flag" :style="{ background: item.color }"></span>
            <label class="warn-text">{{ item.label }}</label>
          </li>
        </ul>
      </div>
      <!-- 表格数据 -->
      <el-table
        :data="tableData"
        ref="table"
        border
        v-load="loading"
        :loading-text="$t('989')"
        style="min-height: 100px"
      >
        <!-- 姓名 -->
        <el-table-column prop="staff_name" fixed="left" align="center" :label="$t('22')" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.staff_name }}</span>
            <span v-if="scope.row.staff_code">({{ scope.row.staff_code }})</span>
          </template>
        </el-table-column>
        <!-- 部门 -->
        <el-table-column prop="department_name" align="center" :label="$t('27')"></el-table-column>
        <!-- 职位 -->
        <el-table-column prop="job_title_name" fixed="left" align="center" :label="$t('24')"></el-table-column>
        <!-- 群组 -->
        <el-table-column prop="as_group_name" align="center" :label="$t('526')"></el-table-column>
        <!-- 在职状态 -->
        <el-table-column prop="state_txt" align="center" :label="$t('state')"></el-table-column>
        <el-table-column
          v-for="(item, index) in checkArr"
          :prop="item.prop"
          :label="item.label"
          :key="index"
        ></el-table-column>
        <!-- 加班 -->
        <el-table-column align="center" :label="$t('82')" v-if="overTime">
          <!-- 工作日加班 -->
          <el-table-column :label="$t('1701')" width="120" align="center">
            <template slot-scope="scope" v-if="scope.row.overtime">
              <span class="ot-span" @click="handlerOtClick(scope.row, 1, '1701')">
                {{ scope.row.overtime['ot_1_duration'] }}</span
              >
            </template>
          </el-table-column>
          <!-- 休息日加班 -->
          <el-table-column :label="$t('rest_day_overtime')" width="120" align="center">
            <template slot-scope="scope" v-if="scope.row.overtime">
              <span class="ot-span" @click="handlerOtClick(scope.row, 2, 'rest_day_work')">
                {{ scope.row.overtime['ot_2_duration'] }}</span
              >
            </template>
          </el-table-column>
          <!-- 休息日上班 -->
          <el-table-column :label="$t('rest_day_work')" width="120" align="center">
            <template slot-scope="scope" v-if="scope.row.overtime">
              <span class="ot-span" @click="handlerOtClick(scope.row, 3, 'rest_day_overtime')">
                {{ scope.row.overtime['ot_3_duration'] }}</span
              >
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column v-for="item in timeArr" class="cloumn" :key="item" :prop="item" :label="item">
          <el-table-column label="in" width="140">
            <template slot-scope="scope">
              <el-tooltip
                effect="light"
                :content="$t('i18n.Ka19WXddkToR')"
                placement="top-start"
                popper-class="poperClass"
                :disabled="!$p('menu.statistics.edit')"
              >
                <div
                  class="tb-cloumn"
                  :style="{
                    color: colorStr(scope.row[item], 'start_state')
                  }"
                  @click="
                    openAttendanceDetailsDialog({
                      staff_id: scope.row.staff_id,
                      attendance_date: scope.row[item]['date']
                    })
                  "
                >
                  <!-- <p
                    v-if="scope.row[item]['in_can_click'] || scope.row[item]['in_leave']"
                    @click="
                      canClick({
                        type: scope.row[item].in_leave ? 'leave' : 'attendance',
                        staff_id: scope.row.staff_id,
                        attendance_date: scope.row[item]['date'],
                        attendance_category: 1
                      })
                    "
                  >
                    <el-link>{{ formateValue(scope.row[item], 'in') }}</el-link>
                  </p> -->
                  <p>
                    <span>{{ formateValue(scope.row[item], 'in') }}</span>
                  </p>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="out" width="140">
            <template slot-scope="scope">
              <el-tooltip
                effect="light"
                :content="$t('i18n.Ka19WXddkToR')"
                placement="top-start"
                popper-class="poperClass"
                :disabled="!$p('menu.statistics.edit')"
              >
                <div
                  class="tb-cloumn"
                  :style="{ color: colorStr(scope.row[item], 'end_state') }"
                  @click="
                    openAttendanceDetailsDialog({
                      staff_id: scope.row.staff_id,
                      attendance_date: scope.row[item]['date']
                    })
                  "
                >
                  <!-- <p
                    v-if="scope.row[item]['out_can_click'] || scope.row[item]['out_leave']"
                    @click="
                      canClick({
                        type: scope.row[item].out_leave ? 'leave' : 'attendance',
                        staff_id: scope.row.staff_id,
                        attendance_date: scope.row[item]['date'],
                        attendance_category: 2
                      })
                    "
                  >
                    <el-link>{{ formateValue(scope.row[item], 'out') }}</el-link>
                  </p> -->
                  <p>
                    <span>{{ formateValue(scope.row[item], 'out') }}</span>
                  </p>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-sizes="[20, 60, 80, 100]"
        :page-size="form.page_size"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="form.count"
      ></el-pagination>
      <punch-dialog v-if="isPunchDialog" ref="punch-dialog" />
      <!-- 加班详情 -->
      <ot-dialog v-if="otVisible" :visible.sync="otVisible" ref="otDia" />
      <AttendanceDetailsDialog ref="AttendanceDetailsDialog" @confirm="handleGetAttendance" />
    </div>
  </div>
</template>

<script>
// 接口api
import { getAttendance, attendanceExcel } from 'api/Attendance'
// 获取在职状态
import { sysInfoFn } from 'api/org/per'
// 部门
import department from '@/components/department'
// 职位
import job from '@/components/jobSelect'
// 时间选择
import datePacker from '@/components/date-picker'
// 色值 选项
import { colors, checkData } from './config'
// 详情
import punchDialog from './punch-dialog'
// 加班详情dialog
import otDialog from './components/ot-dialog'
import AttendanceDetailsDialog from './AttendanceDetailsDialog.vue'

export default {
  name: 'statis',
  components: {
    department,
    job,
    datePacker,
    punchDialog,
    otDialog,
    AttendanceDetailsDialog
  },
  data() {
    return {
      otVisible: false,
      // 表格数据load
      loading: false,
      // 加班动态展示
      overTime: false,
      // 在职状态
      stateArr: [],
      checkList: [],
      checkArr: [],
      checkData: checkData(this),
      colors: colors(this),
      defaultProps: {},
      value: '',
      radio: '',
      form: {
        page: 1,
        page_size: 20,
        start_date: '',
        end_date: '',
        states: ['1', '3']
      },
      tableData: [{}],
      options: [],
      props: {},
      dataCloumn: {
        d: 31
      },
      timeArr: [],
      // 动态计算表格高度
      heightTab: 0,
      isPunchDialog: false
    }
  },
  created() {
    this.handleCloumn()
    this.sysInfoFn()
  },
  mounted() {
    this.handleGetAttendance()
  },
  methods: {
    // @parma { Object } row 当前行
    // @parma { Number } ot_type 加班类型
    // @parma { Number } title 加班类型翻译key
    handlerOtClick(row, ot_type, title) {
      const msg = {
        ...this.form,
        ...row,
        title,
        ot_type
      }
      this.otVisible = true
      this.$nextTick(() => {
        this.$refs.otDia.handlerGetData(msg)
      })
    },
    // 获取在职状态
    async sysInfoFn() {
      const res = await sysInfoFn()
      this.stateArr = res.data.state
    },
    // 日期筛选赋值
    handlerInputChange(obj) {
      if (obj && Array.isArray(obj) && obj.length) {
        this.form.start_date = obj[0]
        this.form.end_date = obj[1]
      }
    },
    // 表格数据格式化
    formateValue(val, str) {
      return (val && val[str]) || ''
    },
    formateRemark(val, type) {
      const key = type === 'in' ? 'start_remark' : 'end_remark'
      return val && val[key] ? val[key] : 'empty'
    },
    // 搜索
    handlerSearch() {
      this.form.page = 1
      this.handleGetAttendance()
    },
    // 部门选择
    handlerChangeDep(a, b) {
      this.form.department_id = b.slice(-1)[0]
    },
    // 左侧checkbox change事件
    handlerChangeSelect(v) {
      const arr = []
      v.forEach(element => {
        this.checkData.forEach(item => {
          if (item.label === element) {
            arr.push(item)
          }
        })
      })
      this.checkArr = arr
      // this.$nextTick(() => this.$refs.table.doLayout && this.$refs.table.doLayout())
    },
    // 生成key
    createKey() {
      return new Date().getTime()
    },
    // 生成表格列循环月key
    createLabel(item) {
      return `0${this.dataCloumn.m}-${item < 9 ? '0' + (item + 1) : item + 1}`
    },
    // 表格循环颜色标注
    colorStr(val, str) {
      if (!val || !val[str]) return '#FFF'
      val = Number(val[str])
      const mapColors = new Map([
        [1, this.colors[0].color],
        [2, this.colors[1].color],
        [3, this.colors[2].color],
        [4, this.colors[3].color]
      ])
      return mapColors.get(val) || '#FFF'
    },
    //  分页相关
    handleSizeChange(val) {
      this.form.page_size = val
      this.handleGetAttendance()
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.handleGetAttendance()
    },
    // 获取考勤统计数据
    handleGetAttendance() {
      this.loading = true
      getAttendance(this.form)
        .then(res => {
          const { data } = res
          this.form.count = data.count
          this.tableData = data.datalist
          this.timeArr = data.days
          // this.$nextTick(() => this.$refs.table.doLayout && this.$refs.table.doLayout())
        })
        .finally(() => {
          this.loading = false
        })
    },
    formateTimeOwon(arr) {
      const [start, end] = arr
      let currentTime = new Date(start.split('')[0]).getTime()
      const endTime = new Date(end.split('')[0]).getTime()
      while (currentTime < endTime) {
        const time = this.$util.parseTime(new Date(currentTime), 'm-d')
        this.timeArr.push(time)
        currentTime += 86400000
      }
    },
    // 初始化时间
    handleCloumn() {
      const date = new Date()
      const y = date.getFullYear()
      const m = date.getMonth() + 1
      const d = date.getDate()
      this.dataCloumn = {
        y,
        m,
        d
      }
      this.form.start_date = `${y}-${m}-1`
      this.form.end_date = `${y}-${m}-${d}`
    },
    handlerAttendanceExcel() {
      attendanceExcel(this.form).then(res => {
        window.open(res.data.object_url)
      })
    },
    canClick() {
      this.isPunchDialog = true
      this.$nextTick(() => this.$refs['punch-dialog'].init(...arguments))
    },
    openAttendanceDetailsDialog(params) {
      this.$refs.AttendanceDetailsDialog.init(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.tb-cloumn {
  height: 100%;
  cursor: pointer;
}
.ot-span {
  display: inline-block;
  padding: 10px 12px;
  cursor: pointer;
  user-select: none;
  &:hover {
    color: $theme;
    text-decoration: underline;
  }
}
/deep/ .tb-cloumn {
  width: 100%;
  padding: 10px;
  vertical-align: middle;
  p {
    display: inline-block;
    width: 100%;
  }

  p:hover {
    span {
      color: #409eff;
    }
  }
}
/deep/ .el-table--mini td,
.el-table--mini th {
  padding: 0;
  .cell {
    padding: 0;
    text-align: center;
  }
}
.radio-wrap {
  line-height: 60px;
}
/deep/ .el-checkbox__label {
  font-size: 13px;
}
.by-list-title {
  line-height: 1;
  height: 18px;
  color: $menuBg;
  font-weight: 600;
}
.colors-wrap {
  margin: 10px 0;
  text-align: right;
  .warn-color {
    display: inline-block;
    margin-left: 20px;
    font-size: 13px;
    .warn-flag {
      display: inline-block;
      margin-right: 10px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }
}
.search_name {
  min-width: 320px;
}
</style>
